import * as React from "react";
import * as ReactRedux from "react-redux";
import Header from "../components/Header/Header";
import Footer from "../components/Footer/Footer";
import "../styles/devportal.scss";
import { useUser, useIsAuthed } from "../auth";
import { actions, selectors } from "../reducers/lab";

const HeaderFooterLayout = ({ children, getCurrentUser, setIsLogged, closeLab, selectedLabUser, setSelectedUser}) => {
	const isAuth = useIsAuthed();
	const user = useUser();

	React.useEffect(() => {
		if (!isAuth) {
			setIsLogged(false);
            closeLab();
			return;
		}
		if (user) {
			const data = {
				firstName: user.profile.name.split(" ")[0],
				lastName: user.profile.name.split(" ")[1],
				id: user.profile.default_business_id,
				isAdmin: true,
				accessToken: user.access_token,
				refreshToken: user.refresh_token,
			};
			getCurrentUser(data);
			setIsLogged(true);
            if (!selectedLabUser) {
                setSelectedUser({
                    type: "user",
                    id: data.id
                })
            }
		}
	}, [isAuth, user]);

	return (
		<>
			<Header />
			{children}
			<Footer />
		</>
	);
};

const mapStateToProps = (state) => ({
	selectedLabUser: selectors.selectSelectedLabUser(state),
});

const mapDispatchToProps = {
	getCurrentUser: actions.getCurrentUser,
	setIsLogged: actions.setIsLogged,
	closeLab: actions.close,
    setSelectedUser: actions.setSelectedUser
};

export default ReactRedux.connect(mapStateToProps, mapDispatchToProps)(HeaderFooterLayout);
